"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteModule = void 0;
const stack_1 = require("../types/stack");
const stack_2 = require("./stack");
const crypto_1 = require("@akord/crypto");
const note_1 = require("../types/note");
const query_options_1 = require("../types/query-options");
const node_1 = require("./node");
const constants_1 = require("../constants");
class NoteModule extends node_1.NodeModule {
    constructor(wallet, api) {
        super(wallet, api, stack_1.Stack, constants_1.objectType.STACK);
        this.defaultCreateOptions = {
            parentId: undefined,
            mimeType: note_1.NoteTypes.MD
        };
        this.stackModule = new stack_2.StackModule(wallet, api);
    }
    /**
     * Get note version by index, return the latest version by default
     * @param  {string} noteId
     * @param  {number} [index] note version index
     * @returns Promise with version name & data string
     */
    getVersion(noteId, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const { name, data } = yield this.stackModule.getVersion(noteId, index, { responseType: 'arraybuffer' });
            return { data: (0, crypto_1.arrayToString)(data), name: name };
        });
    }
    /**
     * @param  {string} vaultId
     * @returns Promise with all notes within given vault
     */
    list(vaultId, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, query_options_1.validateListPaginatedApiOptions)(options);
            const stacks = yield this.stackModule.list(vaultId, options);
            const notes = stacks.items.filter((stack) => this.isValidNoteType(stack.getVersion().type));
            return { items: notes, nextToken: stacks.nextToken };
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {string} content note content, ex: stringified JSON
     * @param  {string} name note name
     * @param  {NoteCreateOptions} [options] parent id, mime type, etc.
     * @returns Promise with new note id & corresponding transaction id
     */
    create(vaultId, content, name, options = this.defaultCreateOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const createOptions = Object.assign(Object.assign({}, this.defaultCreateOptions), options);
            const { stackId, transactionId, object } = yield this.stackModule.create(vaultId, [content], Object.assign(Object.assign({}, createOptions), { name }));
            return { noteId: stackId, transactionId, object };
        });
    }
    /**
     * @param  {string} noteId
     * @param  {string} content note content, ex: stringified JSON
     * @param  {string} name note name
     * @param  {NoteOptions} [options] parent id, mime type, etc.
     * @returns Promise with corresponding transaction id
     */
    uploadRevision(noteId, content, name, options = this.defaultCreateOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.stackModule.uploadRevision(noteId, [content], { name, mimeType: options.mimeType });
        });
    }
    isValidNoteType(type) {
        return Object.values(note_1.NoteTypes).includes(type);
    }
}
exports.NoteModule = NoteModule;
;
